<template>
  <div class="product-page container mx-auto">
    <div
      class="row flex-nowrap justify-content-around mx-auto text-black border-bottom border-danger text-center m-5"
    >
      <h1 class="col-12 text-uppercase mt-2" id="ty-quo">
        Hartelijk dank voor uw offerteaanvraag, wij nemen de aanvraag in
        behandeling
      </h1>
    </div>

    <!-- <router-link
      to="/"
      class="link-assortiments terug-knop bg-gray text-uppercase"
      type="button"
    >
      Terug naar overzicht
    </router-link> -->
    <div class="d-flex justify-content-center">
      <NavButton :properties="HomeButton" />
    </div>
  </div>
</template>
<script>
import NavButton from "@/components/NavButton.vue";

export default {
  name: "Outro",
  components: {
    NavButton,
  },
  data() {
    return {
      HomeButton: {
        routeName: this.$RouteNames.assortment,
        class:
          "btn btn-grey text-uppercase p-1 text-center link-assortiments ms-1",
        id: "",
        label: "Terug naar overzicht",
        type: "button",
        function: undefined,
      },
    };
  },
  unmounted() {
    this.$store.commit("clearCART");
  },
  created() {
    this.$store.commit("storeLocUpdate", true);
  },
};
</script>
